// Einstellungen tab: write-only API-key form for the marketing suite.
import type { MarketingDeps } from "./marketing.js";

interface SecretsResponse { secrets: Array<{ key: string; isSet: boolean }> }

const KEY_LABEL: Record<string, string> = {
  ANTHROPIC_API_KEY: "Anthropic API-Key (Blog-/Caption-Texte)",
  OPENAI_API_KEY: "OpenAI API-Key (Bild-Generierung, P3)",
  METRICOOL_API_TOKEN: "Metricool API-Token (Publishing + Analytics, P4)",
  FAL_API_KEY: "fal.ai API-Key (Video-Generierung, P4 · Key …)",
  ANTHROPIC_ADMIN_KEY: "Anthropic Admin-Key (Kosten-Tracking · sk-ant-admin…)",
  OPENAI_ADMIN_KEY: "OpenAI Admin-Key (Kosten-Tracking · sk-admin…)",
  SISTRIX_API_KEY: "SISTRIX API-Key (Onpage-Crawler-Fehler → SEO-Check)",
  AWIN_API_TOKEN: "Awin API-Token (Benutzer „Claude“ · ui.awin.com/awin-api · nur lesend)",
};

export function initSettingsTab(m: HTMLElement, deps: MarketingDeps): void {
  const host = m.querySelector("[data-secrets-form]") as HTMLElement | null;
  const msg = m.querySelector('[data-msg="settings"]') as HTMLElement | null;
  if (!host || !msg) return;

  const load = async (): Promise<void> => {
    const r = await deps.api<SecretsResponse>("/api/marketing/secrets");
    const secrets = r.data?.secrets ?? [];
    host.textContent = "";
    for (const s of secrets) {
      const row = document.createElement("div");
      row.className = "om-secret-row";

      const label = document.createElement("label");
      label.textContent = KEY_LABEL[s.key] ?? s.key;

      const wrap = document.createElement("span");
      wrap.className = "password-wrap";
      const input = document.createElement("input");
      input.type = "password";
      input.placeholder = s.isSet ? "✓ hinterlegt — neu eingeben zum Überschreiben" : "noch nicht hinterlegt";
      input.autocomplete = "off";
      const reveal = document.createElement("button");
      reveal.type = "button";
      reveal.className = "reveal-btn";
      reveal.title = "Anzeigen/Verbergen";
      reveal.textContent = "👁";
      wrap.appendChild(input);
      wrap.appendChild(reveal);
      label.appendChild(wrap);

      const save = document.createElement("button");
      save.className = "btn-primary";
      save.textContent = "Speichern";
      save.addEventListener("click", () => {
        void (async () => {
          const value = input.value.trim();
          if (!value) { msg.textContent = "Bitte Wert eingeben."; return; }
          const res = await deps.api(`/api/marketing/secrets/${s.key}`, "PUT", { value });
          msg.textContent = res.status === 200 ? `${s.key} gespeichert.` : `Fehler (${res.status})`;
          input.value = "";
          await load();
        })();
      });

      row.appendChild(label);
      row.appendChild(save);
      host.appendChild(row);
    }
  };

  // Optional USD→EUR rate (written into marketing_api_prices.json, used by the
  // cost aggregator). Lives outside the secrets list — plain config value.
  const rateInput = m.querySelector("[data-eur-rate]") as HTMLInputElement | null;
  m.querySelector('[data-action="save-eur-rate"]')?.addEventListener("click", () => {
    void (async () => {
      const rate = Number(rateInput?.value);
      if (!Number.isFinite(rate) || rate <= 0) { msg.textContent = "Bitte einen gültigen Kurs eingeben."; return; }
      const res = await deps.api("/api/marketing/eur-rate", "PUT", { rate });
      msg.textContent = res.status === 200 ? `EUR-Kurs gespeichert (${rate}).` : `Fehler (${res.status})`;
    })();
  });

  void load();
}
